(function(){
  function ready(fn){if(document.readyState!=='loading'){fn()}else{document.addEventListener('DOMContentLoaded',fn)}}
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(scope){
    if(reduce||!('IntersectionObserver' in window))return;
    var els=[].slice.call(scope.querySelectorAll('.mgi[data-animate] .mgi-r'));
    if(!els.length)return;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mgi-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.06});
    els.forEach(function(el){io.observe(el)});
    function fb(){var vh=window.innerHeight;els.forEach(function(el){if(el.classList.contains('mgi-in'))return;var r=el.getBoundingClientRect();if(r.top<vh&&r.bottom>0){el.classList.add('mgi-in');io.unobserve(el)}})}
    fb();setTimeout(fb,400);setTimeout(fb,1400);window.addEventListener('load',fb);
  }

  function initLibrary(scope){
    [].slice.call(scope.querySelectorAll('[data-mgi-lib]')).forEach(function(root){
      if(root.__mgiInit)return;root.__mgiInit=true;
      var input=root.querySelector('[data-mgi-search]');
      var famPills=[].slice.call(root.querySelectorAll('[data-mgi-fam]'));
      var prodPills=[].slice.call(root.querySelectorAll('[data-mgi-prod]'));
      var cards=[].slice.call(root.querySelectorAll('[data-mgi-card]'));
      var empty=root.querySelector('[data-mgi-empty]');
      var state={q:'',fam:'all',prod:'all'};
      function apply(){
        var shown=0;
        cards.forEach(function(c){
          var okF=state.fam==='all'||c.getAttribute('data-family')===state.fam;
          var okP=state.prod==='all'||(c.getAttribute('data-products')||'').indexOf(state.prod)>-1;
          var okQ=!state.q||(c.getAttribute('data-text')||'').indexOf(state.q)>-1;
          var ok=okF&&okP&&okQ;
          if(ok){c.removeAttribute('hidden');shown++}else{c.setAttribute('hidden','')}
        });
        if(empty)empty.style.display=shown?'none':'block';
      }
      if(input){input.addEventListener('input',function(){state.q=input.value.trim().toLowerCase();apply()})}
      famPills.forEach(function(p){p.addEventListener('click',function(){famPills.forEach(function(o){o.classList.remove('on')});p.classList.add('on');state.fam=p.getAttribute('data-mgi-fam');apply()})});
      prodPills.forEach(function(p){p.addEventListener('click',function(){prodPills.forEach(function(o){o.classList.remove('on')});p.classList.add('on');state.prod=p.getAttribute('data-mgi-prod');apply()})});
      cards.forEach(function(c){
        var t=c.querySelector('.mgi-card-toggle');
        if(t)t.addEventListener('click',function(){var open=c.classList.toggle('open');t.setAttribute('aria-expanded',open?'true':'false')});
      });
      root.__mgiSetFam=function(f){var p=famPills.filter(function(x){return x.getAttribute('data-mgi-fam')===f})[0];if(p)p.click()};
      apply();
    });
    [].slice.call(scope.querySelectorAll('[data-mgi-goto]')).forEach(function(btn){
      if(btn.__mgiInit)return;btn.__mgiInit=true;
      btn.addEventListener('click',function(e){
        var lib=document.querySelector('[data-mgi-lib]');
        if(!lib)return;
        e.preventDefault();
        if(lib.__mgiSetFam)lib.__mgiSetFam(btn.getAttribute('data-mgi-goto'));
        lib.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});
      });
    });
  }

  function initAll(scope){initReveals(scope||document);initLibrary(scope||document)}
  ready(function(){initAll(document)});
  document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
})();
